export default "__VITE_ASSET__fb16a323__"